import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import React, {useCallback, useEffect} from 'react';
import {useHistory} from 'react-router-dom';

let pastLocations = [];

export function updatePastLocations(location, action) {
  switch (action) {
    case 'PUSH':
      // first location when app loads and when pushing onto history
      pastLocations.push(location);
      break;
    case 'REPLACE':
      // only when using history.replace
      pastLocations[pastLocations.length - 1] = location;
      break;
    case 'POP': {
      // happens when using the back button, or forward button
      pastLocations.pop();
      // location according to pastLocations
      const appLocation = pastLocations[pastLocations.length - 1];
      if (!(appLocation && appLocation.key === location.key)) {
        // If the current location doesn't match what the app thinks is the current location,
        // blow up the app history.
        pastLocations = [location];
      }
      break;
    }
    default:
  }
}

export function isPreviousLocationWithinApp() {
  return pastLocations.length > 0;
}

export function BackButtonListener() {
  const history = useHistory();

  useEffect(() => {
    return history.listen(updatePastLocations);
  }, [history]);

  return null;
}

export function useBack() {
  const history = useHistory();
  return useCallback(() => {
    const {pathname} = history.location;
    const parts = pathname.split('/');
    parts.pop();
    const to = parts.join('/');
    if (isPreviousLocationWithinApp()) {
      history.goBack();
    } else {
      history.replace(to || '/');
    }
  }, [history]);
}
// export function useBack() {
//   const history = useHistory();

//   return useCallback(() => {
//     const { pathname } = history.location;
//     const parts = pathname.split("/");
//     parts.pop();
//     const to = parts.join("/");
//     if (isPreviousLocationWithinApp()) {
//       if (navigator.userAgent.indexOf("Safari") > -1) {
//         // Use history.push instead of history.goBack for Safari
//         history.push(to || "/");
//       } else {
//         history.goBack();
//       }
//     } else {
//       history.replace(to || "/");
//     }
//   }, [history]);
// }

export default React.memo(function BackButton({
  component: Component,
  ...props
}) {
  const onClick = useBack();

  if (Component) {
    return <Component {...props} onClick={onClick} />;
  }

  return (
    <IconButton color="inherit" {...props} onClick={() => onClick()}>
      {props.children || <ArrowForwardIcon />}
    </IconButton>
  );
});
